module.exports = __webpack_public_path__ + "static/media/fed.6ee39480.svg";